import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useI18n } from "../../i18n/LanguageContext";
import { Button } from "../../components/ui/button";
import { Download, KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function SuperAdminEnrollments() {
  const { t } = useI18n();
  const [rows, setRows] = useState(null);

  const load = () => { setRows(null); api.saEnrollments({ limit: 100 }).then(setRows).catch((e) => { toast.error(e.message); setRows([]); }); };
  useEffect(() => { load(); }, []);

  const forceAll = async (e) => {
    if (!window.confirm(t("superadmin.forceUnlockAll") + " ?")) return;
    try { await api.saForceUnlock(e.enrollment_id, "all"); toast.success("✓"); load(); }
    catch (err) { toast.error(err.message); }
  };

  return (
    <div className="space-y-6" data-testid="sa-enrollments-page">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-[#F72585]">{t("superadmin.title")}</div>
          <h1 className="text-3xl md:text-4xl font-black tracking-tight">{t("superadmin.enrollments")}</h1>
        </div>
        <a href={api.saExportUrl("enrollments")} target="_blank" rel="noreferrer"
           className="inline-flex items-center gap-2 rounded-full bg-white border border-black/10 px-4 py-2 text-sm font-bold hover:bg-black/5"
           data-testid="sa-export-enrollments-link">
          <Download className="h-4 w-4" /> {t("superadmin.exportEnrollments")}
        </a>
      </header>

      <div className="rounded-2xl border border-black/5 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-black/5">
            <tr>
              <Th>enrollment_id</Th><Th>user_id</Th><Th>course_id</Th><Th>enrolled</Th>
              <Th>unlocked</Th><Th>{t("superadmin.actions")}</Th>
            </tr>
          </thead>
          <tbody>
            {rows === null && <tr><td colSpan={6} className="p-6 text-center text-black/50">{t("superadmin.loading")}</td></tr>}
            {rows?.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-black/50">{t("superadmin.empty")}</td></tr>}
            {rows?.map((e) => (
              <tr key={e.enrollment_id} className="border-t border-black/5" data-testid={`sa-enr-${e.enrollment_id}`}>
                <Td className="font-mono text-xs">{e.enrollment_id}</Td>
                <Td className="font-mono text-xs">{e.user_id}</Td>
                <Td className="font-mono text-xs">{e.course_id}</Td>
                <Td className="text-xs text-black/60">{e.enrolled_at?.slice(0, 10)}</Td>
                <Td className="text-xs">{(e.unlocked_module_ids || []).length}</Td>
                <Td>
                  <Button size="sm" onClick={() => forceAll(e)}
                          className="rounded-full bg-[#FFB703]/20 text-[#7A4B00] text-xs font-bold h-7 hover:bg-[#FFB703]/30"
                          data-testid={`sa-forceunlock-${e.enrollment_id}`}>
                    <KeyRound className="h-3 w-3 me-1" /> {t("superadmin.forceUnlockAll")}
                  </Button>
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Th({ children }) { return <th className="text-start px-3 py-2.5 text-[11px] font-black uppercase tracking-wider text-black/60">{children}</th>; }
function Td({ children, className = "" }) { return <td className={`px-3 py-2.5 ${className}`}>{children}</td>; }
